import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type NotificationFilterState = {
  /** 通知ログで非表示にしているドメイン。空なら全表示 */
  hiddenDomains: string[]
  setHiddenDomains: (domains: string[]) => void
}

export const useNotificationFilterStore = create<NotificationFilterState>()(
  persist(
    (set) => ({
      hiddenDomains: [],
      setHiddenDomains: (domains) => set({ hiddenDomains: [...domains].sort() }),
    }),
    {
      name: 'notification-filter',
    },
  ),
)
